"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeBanxAdventure = void 0;
const constants_1 = require("../../../constants");
const helpers_1 = require("../../../helpers");
const anchor_1 = require("@project-serum/anchor");
const helpers_2 = require("./helpers");
const subscribeBanxAdventure = ({ programId, connection, addComputeUnits, accounts, optimistics, args, sendTxn, }) => __awaiter(void 0, void 0, void 0, function* () {
    const program = (0, helpers_1.returnAnchorProgram)(programId, connection);
    const instructions = [];
    const [banxTokenStake] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_TOKEN_STAKE_PREFIX), accounts.userPubkey.toBuffer()], program.programId);
    const [banxStakingSettings] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_STAKING_SETTINGS_PREFIX)], program.programId);
    const modifyComputeUnits = anchor_1.web3.ComputeBudgetProgram.setComputeUnitLimit({
        units: Math.round(800000 + Math.ceil(Math.random() * 10000)),
    });
    const requestHeap = anchor_1.web3.ComputeBudgetProgram.setComputeUnitPrice({ microLamports: 6000 });
    instructions.push(requestHeap);
    if (!!addComputeUnits)
        instructions.push(modifyComputeUnits);
    const remainingAccounts = (yield Promise.all(args.weeks.map((week) => __awaiter(void 0, void 0, void 0, function* () {
        const [adventure] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, helpers_2.weeksToBanxAdventureTimestamp)(week).toString())], program.programId);
        const [adventureSubscription] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), accounts.userPubkey.toBuffer()], program.programId);
        return [{
                pubkey: adventure,
                isSigner: false,
                isWritable: true,
            },
            {
                pubkey: adventureSubscription,
                isSigner: false,
                isWritable: true,
            },
        ];
    })))).flat();
    const subscribeBanxAdventureParams = (yield Promise.all(args.weeks.map((week) => __awaiter(void 0, void 0, void 0, function* () {
        const [adventure, adventureBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_PREFIX), constants_1.ENCODER.encode((0, helpers_2.weeksToBanxAdventureTimestamp)(week).toString())], program.programId);
        const [adventureSubscription, adventureSubscriptionBump] = yield anchor_1.web3.PublicKey.findProgramAddress([constants_1.ENCODER.encode(constants_1.BANX_ADVENTURE_SUBSCRIPTION_PREFIX), adventure.toBuffer(), accounts.userPubkey.toBuffer()], program.programId);
        const params = {
            week: new anchor_1.BN(week),
            adventureBump: adventureBump,
            subscriptionBump: adventureSubscriptionBump
        };
        return params;
    })))).flat();
    const accountsIntoInstruction = {
        banxStakingSettings,
        banxTokenStake: banxTokenStake,
        user: accounts.userPubkey,
        systemProgram: anchor_1.web3.SystemProgram.programId,
        rent: anchor_1.web3.SYSVAR_RENT_PUBKEY,
    };
    instructions.push(yield program.methods
        .subscribeBanxAdventure(subscribeBanxAdventureParams)
        .accountsStrict(accountsIntoInstruction)
        .remainingAccounts(remainingAccounts)
        .instruction());
    const addressesForLookupTable = [
        ...Object.values(accountsIntoInstruction),
        ...Array.from(remainingAccounts, (x) => x.pubkey),
    ];
    const transaction = new anchor_1.web3.Transaction();
    for (let instruction of instructions)
        transaction.add(instruction);
    const signers = [];
    yield sendTxn(transaction, signers);
    const optimisticResult = yield (0, helpers_2.subscribeBanxAdventrueOptimistics)(optimistics, args.weeks);
    return {
        instructions,
        signers,
        addressesForLookupTable,
        optimisticResult,
    };
});
exports.subscribeBanxAdventure = subscribeBanxAdventure;
